import { render, staticRenderFns } from "./DeleteTerm.vue?vue&type=template&id=5a83a73e&scoped=true"
import script from "./DeleteTerm.vue?vue&type=script&lang=js"
export * from "./DeleteTerm.vue?vue&type=script&lang=js"
import style0 from "./DeleteTerm.vue?vue&type=style&index=0&id=5a83a73e&prod&style=true&lang=css"
import style1 from "./DeleteTerm.vue?vue&type=style&index=1&id=5a83a73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83a73e",
  null
  
)

export default component.exports